import { ProductResult } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import ProductTransportTable from './product-detail-transport-table';

interface ProductDetailTransportSectionProps {
  product: ProductResult;
  globalMaxEmissions: number;
}

export default function ProductDetailTransportSection({
  product,
  globalMaxEmissions,
}: ProductDetailTransportSectionProps) {
  const { transport } = product;

  if (product.totalEmissions == null || !transport.transportTypes?.length)
    return null;

  const share = (transport.transportEmissions / product.totalEmissions) * 100;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Text variant="cardTitle" className="text-primary-900">
            Transport
          </Text>
        </div>
        <div className="flex space-x-6">
          <span className="flex items-center space-x-1 text-right font-medium text-teal-600">
            <Icons.pieChart size={16} />
            <Text>{share.toFixed(1)}% of total emissions</Text>
          </span>
        </div>
      </div>
      <ProductTransportTable
        transportTypes={transport.transportTypes || []}
        maxEmissions={globalMaxEmissions}
        totalEmissions={product.totalEmissions!}
        product={product.name}
      />
    </div>
  );
}
